<template>
  <div class="billOperationRecord public_Spacing sale-rate-page">
    <div class="sale-rate-hero">
      <div class="sale-rate-hero-main">
        <span class="sale-rate-eyebrow">SALE RATE</span>
        <h2>费率管理</h2>
        <p>集中维护充电费率、计费说明、下发范围与版本状态，快速处理费率配置。</p>
      </div>
      <div class="sale-rate-hero-metrics">
        <div class="sale-rate-metric-card">
          <span>当前列表</span>
          <strong>{{ tableData.length || 0 }}</strong>
        </div>
        <div class="sale-rate-metric-card">
          <span>费率总数</span>
          <strong>{{ pagingPageMo || 0 }}</strong>
        </div>
      </div>
    </div>
    <div class="pulbic_oparetionBlock sale-rate-filter-card">
      <div class="sale-rate-section-head">
        <div>
          <strong>筛选费率</strong>
          <span>按费率名称、创建人快速定位费率配置</span>
        </div>
      </div>
      <div class="sale-rate-filter-body">
        <div class="public_criteriaRange sale-rate-filter-row">
          <div class="public_oparetionBlock_Menu">
            <label class="public_lbSty">费率名称：</label>
            <div class="el-select public_optionSty">
              <div class="el-input el-input--suffix">
                <input
                  class="el-input__inner pulic_carNumber"
                  type="text"
                  placeholder="请输入"
                  v-model="ormtb608ca01"
                />
              </div>
            </div>
          </div>

          <div class="public_oparetionBlock_Menu">
            <label class="public_lbSty">创建人：</label>
            <div class="el-select public_optionSty">
              <div class="el-input el-input--suffix">
                <input
                  maxlength="7"
                  class="el-input__inner pulic_carNumber"
                  type="text"
                  placeholder="请输入"
                  v-model="ormtb410ca00"
                />
              </div>
            </div>
          </div>
        </div>
        <div class="public_operatArea">
          <div class="public_operatBtn sale-rate-filter-actions">
            <button
              @click="queryClick"
              class="public_saleWater_chaxun pulic_cursor"
              id="搜索"
              v-shiroHiden="solelist"
            >
              搜索
            </button>
            <button
              v-shiroHiden="solelist"
              id="搜索"
              class="public_saleWater_daochu pulic_cursor"
              @click="reset"
            >
              重置
            </button>
          </div>
        </div>
      </div>
    </div>
    <div class="billOperationRecord-table pulbic_table_container sale-rate-table-card">
      <div class="sale-rate-table-head">
        <div>
          <strong>费率列表</strong>
          <span>查看费率版本、下发范围、桩数量和更新时间</span>
        </div>
        <div class="sale-rate-table-head-right">
          <div class="sale-rate-table-total">共 {{ pagingPageMo || 0 }} 条</div>
          <div class="public_operatBtn sale-rate-table-actions">
            <div
              class="pulic_cursor public_operatBtn_btn public_operatBtn_add "
              @click="addClick"
              id="新增"
              v-shiroHiden="solelist"
            >
              <i class="el-icon-plus"></i>新增
            </div>
            <div
              class="pulic_cursor public_operatBtn_btn public_operatBtn_delete"
              @click="allhandleDelete"
              id="删除"
              v-shiroHiden="solelist"
            >
              <i class="el-icon-delete"></i>删除
            </div>
          </div>
        </div>
      </div>
      <el-table
        ref="multipleTable"
        tooltip-effect="dark"
        :data="tableData"
        style="width: 100%;"
        max-height="90%"
        :header-cell-style="{
          color: 'rgba(255,255,255,1)',
          'font-weight': 'bold',
        }"
        @selection-change="handleSelectionChange"
        class="public_tableColumn"
      >
        <el-table-column type="selection" width="55"> </el-table-column>
        <el-table-column prop="ormtb608id" label="费率ID">
          <template slot-scope="scope">
            <p>
              <span>{{ scope.row.ormtb608id }}</span>
            </p>
          </template>
        </el-table-column>
        <el-table-column
          prop="ormtb608ca01"
          label="费率名称"
          show-overflow-tooltip
        >
          <template slot-scope="scope">
            <el-tooltip
              v-if="scope.row.ormtb608ca01.length > 11"
              class="custom_tooltip"
              effect="dark"
              :content="scope.row.ormtb608ca01"
              placement="top"
            >
              <p>
                <span class="name_length">{{ scope.row.ormtb608ca01 }}</span>
              </p>
            </el-tooltip>
            <p v-else>
              <span class="name_length">{{ scope.row.ormtb608ca01 }}</span>
            </p>
          </template>
        </el-table-column>
        <el-table-column
          prop="ormtb608ca02"
          label="计费说明"
          show-overflow-tooltip
        >
          <template slot-scope="scope">
            <el-tooltip
              v-if="scope.row.ormtb608ca02.length > 11"
              class="custom_tooltip"
              effect="dark"
              :content="scope.row.ormtb608ca02"
              placement="top"
            >
              <p>
                <span class="name_length">{{ scope.row.ormtb608ca02 }}</span>
              </p>
            </el-tooltip>
            <p v-else>
              <span class="name_length">{{ scope.row.ormtb608ca02 }}</span>
            </p>
          </template>
        </el-table-column>
        <el-table-column prop="ormtb608ca03" label="桩数量">
          <template slot-scope="scope">
            <p>
              <span v-if="scope.row.ormtb608ca03 == '-'">-</span>
              <span
                v-else
                @click="getPile(scope.row)"
                class="pulic_cursor btn_color_blue"
                >{{ scope.row.ormtb608ca03 }}</span
              >
            </p>
          </template>
        </el-table-column>
        <el-table-column
          prop="ormtb601Name
"
          label="下发范围"
        >
          <template slot-scope="scope">
            <p>
              <span>{{ scope.row.ormtb601Name || '-' }}</span>
            </p>
          </template>
        </el-table-column>
        <el-table-column prop="ormtb608ca17" label="最近更新时间">
          <template slot-scope="scope">
            <p>
              <span>{{ scope.row.ormtb608ca17 || '-' }}</span>
            </p>
          </template>
        </el-table-column>

        <el-table-column prop="ormtb608ca18" label="创建时间">
          <template slot-scope="scope">
            <p>
              <span>{{ scope.row.ormtb608ca18 }}</span>
            </p>
          </template>
        </el-table-column>
        <el-table-column prop="ormtb410id" label="创建人">
          <template slot-scope="scope">
            <p>
              <span>{{ scope.row.createer || '-' }}</span>
            </p>
          </template>
        </el-table-column>
        <el-table-column prop="ormtb608ca16" label="版本号">
          <template slot-scope="scope">
            <p>
              <span>{{ scope.row.ormtb608ca16 }}</span>
            </p>
          </template>
        </el-table-column>
        <el-table-column label="操作" width="328">
          <template slot-scope="scope">
            <el-button
              class="public_icon_xiangqing btn_color_yellow"
              type="primary"
              size="small"
              id="修改"
              v-shiroHiden="solelist"
              @click="handleEdit(scope.row)"
              >修改</el-button
            >
            <el-button
              class="public_icon_xiangqing btn_color_green"
              type="primary"
              size="small"
              id="下发"
              v-shiroHiden="solelist"
              @click="handleIssued(scope.row)"
              >下发</el-button
            >
            <el-button
              class="public_icon_xiangqing btn_color_blue"
              type="primary"
              size="small"
              id="详情"
              v-shiroHiden="solelist"
              @click="detailClick(scope.row)"
              >详情
            </el-button>
            <el-button
              v-if="
                scope.row.ormtb608ca15 &&
                  new Date(scope.row.ormtb608ca15) > new Date()
              "
              class="public_icon_xiangqing btn_color_red"
              type="primary"
              size="small"
              v-shiroHiden="solelist"
              id="关闭"
              @click="handleClose(scope.row)"
              >关闭</el-button
            >
            <el-button
              v-if="scope.row.ormtb608ca03 == '-'"
              class="public_icon_xiangqing btn_color_crimson"
              type="primary"
              size="small"
              id="删除"
              v-shiroHiden="solelist"
              @click="handleDelete(scope.row)"
              >删除</el-button
            >
          </template>
        </el-table-column>
      </el-table>
      <div class="pulbic_pagesize">
        <el-pagination
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          :current-page="pageMo"
          :page-sizes="[10, 20, 30, 40]"
          :page-size="limitMo"
          layout="total,sizes, prev, pager, next, jumper"
          :total="pagingPageMo"
        >
        </el-pagination>
      </div>
    </div>
    <!-- 新增/修改费率弹窗 -->
    <div class="public-dialog">
      <el-dialog
        :title="title"
        :visible.sync="addShow"
        width="900px"
        @close="
          addShow = false
          detailId = null
        "
        :closeOnClickModal="false"
       append-to-body custom-class="sale-rate-dialog">
        <div class="DetailsWater-Dialog">
          <add-component
            v-if="addShow"
            :id="detailId"
            @cancelForm="handleCancel"
            @submitForm="handleSubmit"
          ></add-component>
        </div>
      </el-dialog>
    </div>
    <!-- 下发费率弹窗 -->
    <div class="public-dialog1">
      <el-dialog
        title="下发费率"
        :visible.sync="issuedShow"
        width="900px"
        @close="
          issuedShow = false
          detailId = null
        "
        :closeOnClickModal="false"
       append-to-body custom-class="sale-rate-dialog">
        <div class="DetailsWater-Dialog">
          <el-menu
            class="el-menu-top"
            mode="horizontal"
            text-color="#000"
            active-text-color="#409EFF"
            :default-active="0"
          >
            <el-menu-item :index="0" class="tabActive">下发至站</el-menu-item>
          </el-menu>
          <div class="checkbox_boxs">
            <div class="checkbox_all">
              <el-checkbox v-model="checkAll" @change="handleCheckAllChange"
                ><span class="checkbox_all_text"
                  >全选下发至站</span
                ></el-checkbox
              >
            </div>
            <el-checkbox-group
              class="checkbox_list"
              v-model="checkedStation"
              @change="handleCheckedCitiesChange"
            >
              <div
                class="checkbox_item"
                v-for="(item, index) in stationList"
                :key="index"
              >
                <el-checkbox :label="item.ormtb601id"
                  ><span class="checkbox_item_name">{{
                    item.ormtb601ca00
                  }}</span></el-checkbox
                >
              </div>
            </el-checkbox-group>
          </div>
          <!-- 提交按钮 -->
          <div class="submit_btns">
            <el-button
              class="submit_btns_left"
              @click="
                issuedShow = false
                detailId = null
              "
              >取消</el-button
            >
            <el-button type="primary" @click="handleIssuedSubmit"
              >确定</el-button
            >
          </div>
        </div>
      </el-dialog>
    </div>
    <!-- 下发明细弹窗 -->
    <div class="public-dialog1">
      <el-dialog
        title="下发明细"
        :visible.sync="detailShow"
        width="900px"
        @close="
          detailShow = false
          detailId = null
        "
        :closeOnClickModal="false"
       append-to-body custom-class="sale-rate-dialog">
        <div class="DetailsWater-Dialog">
          <issue-detail
            :id="detailId"
            @issueSubmit="issueSubmit"
            @issueCancel="issueCancel"
          ></issue-detail>
        </div>
      </el-dialog>
    </div>
  </div>
</template>

<script>
import AddComponent from './components/add.vue'
import IssueDetail from './components/issue-detail.vue'
export default {
  components: {
    'add-component': AddComponent,
    'issue-detail': IssueDetail,
  },
  data() {
    return {
      tableData: [],
      multipleSelection: [],
      pageMo: 1, //默认列表页码
      limitMo: 10, //每页的条数
      pagingPageMo: 0, //分页--数据列表共有的条数
      addShow: false,
      issuedShow: false,
      detailShow: false,
      checkAll: false,
      checkedStation: [],
      stationList: [],
      ormtb608ca01: '', //费率名称
      ormtb410ca00: '', //创建人
      detailId: null, //id
      title: '',
      // 历史缓存
      currentUrl: this.$route.path,
      historyInfo: '',
      solelist: [], //权限列表
      userobj: undefined,
    }
  },
  created() {
    var list = ''
    list = this.$store.state.solelist
    var path = this.$route.path
    // 赋值，缓存销毁
    this.historyInfo = JSON.parse(sessionStorage.getItem(this.currentUrl))

    this.userobj = this.$store.state.uobj
    this.solelist = this.$baseAPI.querSoleList(list, path) //获取权限列表

    sessionStorage.removeItem(this.currentUrl)
    if (this.historyInfo != null && this.historyInfo != '') {
      this.init()
    }
  },
  // 存储数据
  beforeDestroy() {
    var obj = {
      ormtb608ca01: this.ormtb608ca01,
      ormtb410ca00: this.ormtb410ca00,
      pageMo: this.pageMo,
      limitMo: this.limitMo,
    }
    sessionStorage.setItem(this.currentUrl, JSON.stringify(obj))
  },
  mounted() {
    this.pageList()
  },
  methods: {
    //初始化数据
    init() {
      this.ormtb608ca01 = this.historyInfo.ormtb608ca01
      this.ormtb410ca00 = this.historyInfo.ormtb410ca00
      this.pageMo = this.historyInfo.pageMo
      this.limitMo = this.historyInfo.limitMo
    },
    issueSubmit() {
      this.detailShow = false
      this.queryClick()
    },
    issueCancel() {
      this.detailShow = false
      this.detailId = null
    },
    getPile(row) {
      this.detailShow = true
      this.detailId = row.ormtb608id
    },
    //下发
    handleIssuedSubmit() {
      let checkedStation = this.checkedStation.join(',')
      var url = 'orm/ormtb608/issued'
      this.axios
        .post(url, { ormtb608id: this.detailId, ormtb601ids: checkedStation })
        .then(res => {
          if (res.data.code == 200) {
            this.$message({
              message: res.data.message,
              type: 'success',
            })
            this.issuedShow = false
            this.queryClick()
          } else {
            this.$message({
              message: res.data.message,
              type: 'error',
            })
          }
        })
        .catch(() => {})
    },
    //获取充电站列表
    getList() {
      var url = 'orm/ormtb601/selecAll601'
      this.axios
        .post(url)
        .then(res => {
          if (res.data.code == 200) {
            this.stationList = res.data.data
          } else {
            this.$message({
              message: res.data.message,
              type: 'error',
            })
          }
        })
        .catch(() => {})
    },
    handleSubmit() {
      this.addShow = false
      this.pageMo = 1
      this.limitMo = 10
      this.tableData = []
      this.pageList()
    },
    reset() {
      this.ormtb608ca01 = ''
      this.ormtb410ca00 = ''
      this.pageMo = 1
      this.limitMo = 10
      this.tableData = []
      this.pageList()
    },
    handleEdit(row) {
      //修改
      if (row.ormtb608ca15 && new Date(row.ormtb608ca15) > new Date()) {
        this.$message.warning('请先关闭定时任务,然后再进行修改操作')
      } else {
        this.title = '修改费率'
        this.addShow = true
        this.detailId = row.ormtb608id
      }
    },
    handleIssued(row) {
      this.getList()
      this.checkAll = false
      this.checkedStation = []
      this.stationList = []
      this.issuedShow = true
      this.detailId = row.ormtb608id
    },
    handleClose(row) {
      this.$confirm(
        '该费率暂未生效，确定要关闭该费率定时下发吗?',
        '关闭定时下发',
        {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning',
        }
      ).then(() => {
        var url = 'orm/ormtb608/shutdownScheduleTask'
        this.axios.post(url, { ormtb608id: row.ormtb608id }).then(res => {
          if (res.data.code == 200) {
            this.$message({
              message: res.data.message,
              type: 'success',
            })
            this.queryClick()
          } else {
            this.$message({
              message: res.data.message,
              type: 'error',
            })
          }
        })
      })
    },
    handleDelete(row) {
      const $this = this
      this.$confirm('此操作将永久删除该文件, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
      })
        .then(async () => {
          if (!row.ormtb608id) {
            $this.$message.error('数据异常,无法删除')
            return
          }

          try {
            const res = await $this.axios.post('/orm/ormtb608/delete', {
              ormtb608ids: row.ormtb608id,
            })

            if (res.data.code === 200) {
              $this.$message.success('删除成功')
              $this.pageList()
            } else {
              $this.$message.error(res.data.message || '删除失败')
            }
          } catch (error) {
            console.error('删除请求失败:', error)
            $this.$message.error('删除请求失败')
          }
        })
        .catch(() => {
          $this.$message.info('已取消删除')
        })
    },
    allhandleDelete() {
      const $this = this
      if (!this.multipleSelection.length) {
        return $this.$message.warning('请选择数据')
      }
      this.$confirm('此操作将永久删除该文件, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
      })
        .then(async () => {
          let ids = this.multipleSelection.map(e => e.ormtb608id).toString()
          if (!ids) {
            $this.$message.error('数据异常,无法删除')
            return
          }

          try {
            const res = await $this.axios.post('orm/ormtb608/delete', {
              ormtb608ids: ids,
            })
            if (res.data.code === 200) {
              $this.$message.success('删除成功')
              $this.pageList()
            } else {
              $this.$message.error(res.data.message || '删除失败')
            }
          } catch (error) {
            console.error('删除请求失败:', error)
            $this.$message.error('删除请求失败')
          }
        })
        .catch(() => {
          $this.$message.info('已取消删除')
        })
    },
    // 下发站全选
    handleCheckAllChange(val) {
      this.checkedStation = val
        ? this.stationList.map(item => item.ormtb601id)
        : []
    },
    handleCheckedCitiesChange(value) {
      let checkedCount = value.length
      this.checkAll = checkedCount === this.stationList.length
    },
    // 打开详情页
    detailClick(row) {
      let tabList = this.$store.state.tablist
      const tabIndex = tabList.findIndex(
        item => item.PERTB001CA05 === 'Home:saleRateDetail'
      )
      if (tabIndex !== -1) {
        tabList.splice(tabIndex, 1) //移除已存在费率详情
      }
      let path = `/Home/saleRateDetail?id=${row.ormtb608id}`
      let resitem = {
        PERTB001CA00: '费率详情',
        PERTB001CA03: `${path}`,
        PERTB001CA04: '1',
        PERTB001CA05: 'Home:saleRateDetail',
        PERTB001CB00: 'ALL',
      }

      var str = JSON.stringify(tabList)
      var index = str.indexOf('/Home/saleRateDetail')
      if (index == -1) {
        var Stablsit = this.$store.state.tablist.slice()
        Stablsit.push(resitem)
        this.$store.commit('upEditableTabs', Stablsit)
      }
      this.$store.commit('setHistTabsValue', path)
      this.$router.push(this.$store.state.setHistTabsValue)
    },
    handleCancel() {
      this.addShow = false
      this.detailId = null
    },
    addClick() {
      this.title = '新增费率'
      this.addShow = true
      this.detailId = null
    },
    handleSelectionChange(val) {
      this.multipleSelection = val
    },
    // 查询
    queryClick() {
      this.pageMo = 1
      this.limitMo = 10
      this.tableData = []
      this.pageList()
    },
    // 列表
    pageList() {
      let loading = this.$loading({
        lock: true,
        text: '请求中...',
        spinner: 'el-icon-loading',
        background: 'rgba(0, 0, 0, 0.5)',
      })
      var postData = {
        ormtb608ca01: this.ormtb608ca01,
        ormtb410ca00: this.ormtb410ca00,
        page: this.pageMo,
        limit: this.limitMo,
      }
      var url = '/orm/ormtb608/selectPageList'
      this.axios
        .post(url, postData)
        .then(res => {
          setTimeout(() => {
            loading.close()
          }, 400)
          if (res.data.code == 200) {
            var data = res.data.data
            this.tableData = data
            console.log(this.tableData, 'oopp')
            this.pagingPageMo = res.data.count
          } else {
            this.$message({
              message: res.data.message,
              type: 'error',
            })
          }
        })
        .catch(() => {
          loading.close()
        })
    },
    handleSizeChange(val) {
      this.pageMo = 1
      this.limitMo = val
      this.pageList()
    },
    // 点击页码
    handleCurrentChange(val) {
      this.pageMo = val
      this.pageList()
    },
  },
}
</script>

<style scoped>
.DWD-li {
  display: flex;
  height: 35px;
  line-height: 35px;
  box-sizing: border-box;
  border: 1px solid #999;
  font-size: 16px;
  color: #333;
}

.DWD-li > div {
  padding: 0 5px;
  height: 34px;
  overflow: hidden;
  box-sizing: border-box;
}

.DWD-li-title {
  width: 120px;
  text-align: center;
  border-right: 1px solid #999;
  background-color: rgba(0, 163, 255, 0.1);
}

.DWD-li-text {
  flex: 1;
}

.DWD-li-text input {
  width: 100%;
  height: 35px;
  line-height: 35px;
  border: none;
  outline: none;
}

.DWD-li + .DWD-li {
  border-top: none;
}

.DWD-table {
  display: flex;
}

.DWD-table-left-flex {
  flex: 1;
}

.DWD-table > div > div {
  padding: 0 5px;
  height: 35px;
  line-height: 35px;
  overflow: hidden;
  text-align: center;
  border-right: 1px solid #999;
  border-bottom: 1px solid #999;
  box-sizing: border-box;
}

.DWD-table > div > div:first-child {
  background-color: rgba(0, 163, 255, 0.1);
}

.DWD-table-left-title > div {
  width: 101px;
  text-align: center;
  background-color: rgba(0, 163, 255, 0.1);
}

.DWD-table .DWD-table-left-title > div {
  padding: 0 5px;
  height: 35px;
  line-height: 35px;
  overflow: hidden;
  box-sizing: border-box;
  border-left: 1px solid #999;
  border-bottom: 1px solid #999;
}
.tabActive {
  color: #199fff !important;
}

.DetailsWater-img {
  margin-top: 30px;
}

.DetailsWater-img-text {
  display: inline-block;
  width: 101px;
  text-align: center;
  vertical-align: top;
}

.car-number-add {
  /* text-transform: uppercase; */
}

.billOperationRecord-table {
  padding: 30px 20px 0;
}

.public_singleMenu .pulic_carNumber {
  margin-top: 6px;
  height: 40px;
  line-height: 40px;
  box-sizing: border-box;
  font-size: 14px;
  display: inline-block;
}

.pulic_operatArea_now:hover,
.public_operatArea_yesterday:hover {
  background-color: #ccc;
}

/* 新增--列表宽度 */
.billOperationRecord .systemCodePC-add-code-table-li-ipt {
  flex: 1.5;
}

.fontBlue {
  color: rgba(25, 159, 255, 1) !important;
}

.public_oparetionBlock_Menu .pulic_carNumber {
  margin-top: 6px;
  height: 40px;
  line-height: 40px;
  box-sizing: border-box;
  font-size: 14px;
  display: inline-block;
}

.billOperationRecord .public_oparetionBlock_Menu {
  height: 45px;
  align-items: center;
}

.billOperationRecord {
  background-color: #f3f3f3;
}

.billOperationRecord th,
.billOperationRecord td {
  text-align: center !important;
}

::v-deep .myCell .el-checkbox__input {
  display: none;
}

.public_operatArea {
  display: flex;
  justify-content: end;
}

.pulic_cursor {
  width: 48px !important;
  height: 32px !important;
  line-height: 32px !important;
  text-align: center;
  border-radius: 4px !important;
  padding: 0 !important;
  font-size: 14px !important;
}

.public_operatBtn {
  display: flex;
  justify-content: end;
}

.public_operatBtn_btn {
  display: flex;
  justify-content: center;
  align-items: center;
  width: 70px !important;
  height: 32px !important;
  border-radius: 4px;
  font-size: 14px;
  margin-bottom: 20px;
  margin-left: 10px;
}

.public_operatBtn_btn > i {
  margin-right: 5px;
}

.public_operatBtn_delete {
  border: 1px solid #ff0000;
  background: #faefef;
  color: #f40000;
}

.public_operatBtn_add {
  background: #e8f4ff;
  border: 1px solid #a3d3ff;
  color: #199fff;
}

/deep/.el-table .has-gutter tr {
  background: #199fff !important;
}

.public-dialog /deep/.el-dialog {
  margin-top: 30px !important;
}


/deep/.el-dialog__body {
  padding-top: 0 !important;
}

/* 下发费率弹窗 */
.checkbox_all {
  width: 100%;
  height: 32px;
  line-height: 32px;
  border-radius: 4px;
  background: #f7f7f7;
  padding-left: 12px;
  margin-top: 15px;
  box-sizing: border-box;
}

.checkbox_all_text {
  font-size: 16px;
  color: #000000;
  font-weight: 700;
}

.checkbox_list {
  max-height: 500px;
  overflow-y: auto;
  padding: 11px 0 0 12px;
  box-sizing: border-box;
  overflow: -moz-scrollbars-none;
  /* 旧版 Firefox */
  scrollbar-width: none;
  /* 新版 Firefox */
  -ms-overflow-style: none;
  /* IE and Edge */
}

.checkbox_list::-webkit-scrollbar {
  width: 0 !important;
  /* Chrome, Safari and Opera */
  height: 0 !important;
}

.checkbox_item {
  margin-top: 13px;
}

.checkbox_item_name {
  font-size: 16px;
  color: #333333;
}

/deep/.el-checkbox__inner {
  margin-top: -5px !important;
}

.name_length {
  display: inline-block;
  width: 166px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

/* 搜索框 */
.search_box {
  width: 100%;
  height: 60px;
  background: #fff;
  padding: 10px 20px;
  box-sizing: border-box;
  display: flex;
  align-items: center;
}

.btn_color_yellow {
  color: #d4b037 !important;
}

.btn_color_green {
  color: #20da9c !important;
}

.btn_color_blue {
  color: #199fff !important;
}

.btn_color_red {
  color: #da2020 !important;
}

.btn_color_crimson {
  color: #ff0000 !important;
}

.el-button + .el-button {
  margin-left: 0px !important;
}

/deep/.el-table td {
  font-size: 14px !important;
}

/* 提交按钮 */
.submit_btns {
  padding-top: 20px;
  display: flex;
  justify-content: end;
}

.submit_btns_left {
  color: #d9d9d9;
  margin-right: 10px;
}

/* 搜索框 */
.search_box {
  width: 100%;
  height: 60px;
  background: #fff;
  padding: 10px 20px;
}
</style>

<style>
.sale-rate-page {
  padding: 18px;
  background: transparent;
  color: #26384d;
}

.sale-rate-hero {
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: 18px;
  margin-bottom: 16px;
  padding: 20px 22px;
  border: 1px solid rgba(226, 214, 190, 0.95);
  border-radius: 18px;
  background: linear-gradient(135deg, #ffffff 0%, #fffaf1 52%, #f7fbff 100%);
  box-shadow: 0 12px 32px rgba(133, 96, 42, 0.08);
  box-sizing: border-box;
}

.sale-rate-hero-main {
  min-width: 0;
}

.sale-rate-eyebrow {
  display: inline-flex;
  align-items: center;
  margin-bottom: 8px;
  padding: 4px 10px;
  border-radius: 999px;
  background: rgba(191, 129, 36, 0.12);
  color: #a86f1a;
  font-size: 12px;
  font-weight: 700;
  letter-spacing: 1.2px;
}

.sale-rate-hero h2 {
  margin: 0;
  color: #2f3b4a;
  font-size: 24px;
  font-weight: 700;
  letter-spacing: 1px;
}

.sale-rate-hero p {
  margin: 8px 0 0;
  color: #68798c;
  font-size: 13px;
  line-height: 1.6;
}

.sale-rate-hero-metrics {
  display: flex;
  gap: 12px;
  flex-shrink: 0;
}

.sale-rate-metric-card {
  min-width: 112px;
  padding: 13px 16px;
  border: 1px solid rgba(231, 218, 194, 0.92);
  border-radius: 14px;
  background: rgba(255, 255, 255, 0.78);
  box-shadow: 0 8px 20px rgba(133, 96, 42, 0.08);
  text-align: center;
  box-sizing: border-box;
}

.sale-rate-metric-card span {
  display: block;
  color: #7b8794;
  font-size: 12px;
}

.sale-rate-metric-card strong {
  display: block;
  margin-top: 6px;
  color: #b56f18;
  font-size: 22px;
  line-height: 1;
}

.sale-rate-filter-card,
.sale-rate-table-card {
  border: 1px solid rgba(231, 224, 210, 0.96);
  border-radius: 16px;
  background: linear-gradient(180deg, #ffffff 0%, #fffdfa 100%);
  box-shadow: 0 10px 26px rgba(133, 96, 42, 0.07);
  box-sizing: border-box;
}

.sale-rate-filter-card {
  margin-bottom: 16px !important;
  padding: 16px 18px;
}

.sale-rate-section-head,
.sale-rate-table-head {
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: 12px;
  margin-bottom: 14px;
}

.sale-rate-table-head {
  padding-top: 6px;
  padding-left: 6px;
}

.sale-rate-section-head strong,
.sale-rate-table-head strong {
  display: block;
  color: #26384d;
  font-size: 16px;
  font-weight: 700;
  letter-spacing: 1px;
}

.sale-rate-section-head span,
.sale-rate-table-head span {
  display: block;
  margin-top: 4px;
  color: #718093;
  font-size: 12px;
}

.sale-rate-filter-body,
.sale-rate-filter-row,
.sale-rate-page .public_oparetionBlock_Menu,
.sale-rate-page .public_operatBtn,
.sale-rate-table-head-right {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: 12px;
}

.sale-rate-filter-body {
  gap: 12px 18px;
}

.sale-rate-table-head-right {
  justify-content: flex-end;
}

.sale-rate-page .public_lbSty {
  width: auto;
  color: #66788c;
  font-weight: 700;
}

.sale-rate-page .public_optionSty {
  width: 240px;
}

.sale-rate-page .pulic_carNumber {
  height: 38px;
  line-height: 38px;
  margin-top: 0;
  border: 1px solid rgba(214, 203, 181, 0.95);
  border-radius: 9px;
  background: #fffdfa;
  color: #25384d;
  box-sizing: border-box;
}

.sale-rate-page .public_operatArea {
  display: flex;
  justify-content: flex-start;
  margin-top: 0;
}

.sale-rate-filter-actions {
  justify-content: flex-start !important;
}

.sale-rate-page .pulic_cursor,
.sale-rate-page .public_operatBtn_btn {
  width: auto !important;
  min-width: 64px;
  height: 36px !important;
  line-height: 36px !important;
  padding: 0 16px !important;
  border-radius: 9px !important;
  font-size: 14px !important;
  font-weight: 700;
  box-sizing: border-box;
}

.sale-rate-page .public_saleWater_chaxun {
  border: 1px solid #b56f18;
  background: linear-gradient(180deg, #cf8730 0%, #b56f18 100%);
  color: #fff;
  box-shadow: 0 8px 16px rgba(181, 111, 24, 0.14);
}

.sale-rate-page .public_saleWater_daochu {
  border: 1px solid #d97706;
  background: linear-gradient(180deg, #f59e0b 0%, #d97706 100%);
  color: #fff;
  box-shadow: 0 8px 18px rgba(217, 119, 6, 0.22);
}

.sale-rate-table-card {
  padding: 18px !important;
}

.sale-rate-table-total {
  margin-right: 8px;
  padding: 6px 12px;
  border-radius: 999px;
  background: #fff4de;
  color: #b56f18;
  font-size: 13px;
  font-weight: 700;
}

.sale-rate-table-actions .public_operatBtn_btn {
  margin: 0 !important;
}

.sale-rate-table-actions .public_operatBtn_add {
  border: 1px solid #8ac2e5;
  background: #eef8ff;
  color: #1f7fb3;
}

.sale-rate-table-actions .public_operatBtn_delete {
  border: 1px solid #f0b4a8;
  background: #fff2ef;
  color: #d94c35;
}

.sale-rate-table-card .el-table {
  border-radius: 12px;
  overflow: hidden;
}

.sale-rate-table-card .el-table .has-gutter tr,
.sale-rate-table-card .el-table th {
  background: linear-gradient(180deg, #d9a75f 0%, #bc7c28 100%) !important;
  color: #fff !important;
}

.sale-rate-table-card .el-table td {
  color: #33485c;
}

.sale-rate-dialog {
  border: 1px solid rgba(226, 214, 190, 0.95);
  border-radius: 18px;
  background: #fffdfa;
  box-shadow: 0 24px 70px rgba(94, 65, 28, 0.20);
  overflow: hidden;
}

.sale-rate-dialog .el-dialog__header {
  padding: 18px 22px;
  background: linear-gradient(135deg, #fffaf1 0%, #fff3df 100%);
  border-bottom: 1px solid rgba(231, 224, 210, 0.95);
}

.sale-rate-dialog .el-dialog__title {
  color: #2f3b4a;
  font-size: 17px;
  font-weight: 700;
  letter-spacing: 1px;
}

.sale-rate-dialog .el-dialog__body {
  padding: 22px !important;
  background: #fffdfa;
}

.sale-rate-dialog .DetailsWater-Dialog {
  padding: 0;
}

.sale-rate-dialog .el-menu-top {
  border-radius: 12px;
  border: 1px solid rgba(231, 224, 210, 0.95);
  overflow: hidden;
}

.sale-rate-dialog .checkbox_all {
  border: 1px solid rgba(231, 224, 210, 0.95);
  border-radius: 10px;
  background: #fff8ec;
}

.sale-rate-dialog .checkbox_list {
  margin-top: 12px;
  padding: 8px 12px 12px;
  border: 1px solid rgba(231, 224, 210, 0.95);
  border-radius: 12px;
  background: #fff;
}

.sale-rate-dialog .checkbox_item {
  margin-top: 10px;
}


.sale-rate-dialog .el-dialog__body {
  max-height: 78vh;
  overflow-y: auto;
}

.sale-rate-dialog .el-dialog__body::-webkit-scrollbar {
  width: 6px;
}

.sale-rate-dialog .el-dialog__body::-webkit-scrollbar-thumb {
  border-radius: 999px;
  background: rgba(181, 111, 24, 0.26);
}

.sale-rate-dialog .el-menu-item.tabActive {
  color: #b56f18 !important;
  font-weight: 700;
  letter-spacing: 1px;
}

.sale-rate-dialog .checkbox_boxs {
  margin-top: 16px;
  padding: 14px;
  border: 1px solid rgba(231, 224, 210, 0.96);
  border-radius: 16px;
  background: linear-gradient(180deg, #ffffff 0%, #fffdfa 100%);
  box-shadow: 0 8px 20px rgba(133, 96, 42, 0.06);
}

.sale-rate-dialog .checkbox_all_text,
.sale-rate-dialog .checkbox_item_name {
  color: #33485c;
}

.sale-rate-dialog .checkbox_item {
  display: inline-flex;
  min-width: 180px;
  margin-right: 14px;
}

.sale-rate-dialog .submit_btns {
  display: flex;
  justify-content: flex-end;
  gap: 24px;
  padding-top: 16px;
  margin-top: 18px;
  border-top: 1px solid rgba(231, 224, 210, 0.95);
}

.sale-rate-dialog .submit_btns_left {
  margin-right: 0;
  color: #9d650f;
}

@media screen and (max-width: 1000px) {
  .sale-rate-hero {
    align-items: stretch;
    flex-direction: column;
  }

  .sale-rate-hero-metrics {
    width: 100%;
  }

  .sale-rate-metric-card {
    flex: 1;
  }

  .sale-rate-table-head {
    align-items: flex-start;
    flex-direction: column;
  }
}
</style>
